import { BaseModel } from "sjs-base-model";

export default class LookUpModel extends BaseModel {
    public readonly key: string = "";
    public readonly value: string = "";

    constructor(data: Partial<LookUpModel>) {
        super();

        this.update(data);
    }
}
